// hooks/useNews.js
import { useState, useEffect } from "react";
import { useHygraph } from "./useHygraph";

export const useNews = () => {
  const [noticies, setNoticies] = useState([]);
  const { fetchFromHygraph, loading, error } = useHygraph();

  const getNoticies = async () => {
    const query = `
      {
        noticies {
          titol
          imatge {
            url
          }
          link
        }
      }
    `;

    const data = await fetchFromHygraph(query);
    if (data && data.noticies) {
      // Transformar les dades per adaptar-les al format que espera el component Stack
      const formattedNews = data.noticies.map((noticia, index) => ({
        id: index + 1, // Generamos IDs numéricos secuenciales ya que no vienen de Hygraph
        img: noticia.imatge.url,
        title: noticia.titol,
        url: noticia.link || `/noticies/${index + 1}`,
      }));

      setNoticies(formattedNews);
    }
  };

  useEffect(() => {
    getNoticies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    noticies,
    loadingNoticies: loading,
    errorNoticies: error,
    refreshNoticies: getNoticies,
  };
};
